const API_BASE_URL = import.meta.env.VITE_API_URL || '';
const GUIAS_BASE_URL = `${API_BASE_URL}/api/guias`;
const GUIAS_EMITIR_URL = `${GUIAS_BASE_URL}/emitir`;

class ApiError extends Error {
  constructor(message, status, payload = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

const buildHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };

  try {
    const token = localStorage.getItem('token');
    const tenantRaw = localStorage.getItem('tenant');

    if (token) headers.Authorization = `Bearer ${token}`;

    if (tenantRaw) {
      try {
        const tenant = JSON.parse(tenantRaw);
        headers['X-Tenant'] = tenant?.code || tenant?.domain || tenantRaw;
      } catch {
        headers['X-Tenant'] = tenantRaw;
      }
    }
  } catch {
    // noop
  }

  return headers;
};

const safeJson = async response => {
  try {
    return await response.json();
  } catch {
    return { ok: false, error: 'Respuesta inesperada del servidor' };
  }
};

const buildEmitirPayload = (payload = {}) => {
  const requestPayload = {
    ...payload,
    estado: 'EMITIDA',
    remitos: Array.isArray(payload.remitos) ? payload.remitos : [],
  };

  return requestPayload;
};

const resolveBackendMessage = payload => (
  payload?.error
  || payload?.message
  || payload?.errors?.[0]?.message
  || null
);

export async function emitirGuia(payload) {
  const requestPayload = buildEmitirPayload(payload);

  const response = await fetch(GUIAS_EMITIR_URL, {
    method: 'POST',
    headers: buildHeaders(),
    credentials: 'include',
    body: JSON.stringify(requestPayload),
  });

  const text = await response.text();
  let data;

  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }

  if (!response.ok) {
    const rawText = typeof text === 'string' ? text.trim() : '';
    const errorMessage = resolveBackendMessage(data) || rawText || `HTTP ${response.status}`;
    throw new ApiError(errorMessage, response.status, data ?? text);
  }

  if (data?.errors?.length) {
    throw new ApiError(resolveBackendMessage(data), response.status, data);
  }

  if (!data) {
    throw new ApiError(`HTTP ${response.status}`, response.status, text);
  }

  return data;
}

export async function createGuia(payload) {
  return emitirGuia(payload);
}

export async function getGuia(id) {
  const response = await fetch(`${GUIAS_BASE_URL}/${id}`, {
    headers: buildHeaders(),
    credentials: 'include',
  });
  return safeJson(response);
}

export default {
  emitirGuia,
  createGuia,
  getGuia,
};
